window.MW.events = (function(){
  var topics = {};
  var hOP = topics.hasOwnProperty;

  return {
    subscribe: function(topic, listener, once) {
      var clear;
      var index;
      var finalListener;
      clear = function() {
        delete topics[topic][index];
      };
      finalListener = once ? function(info) { clear(); listener(info); } : listener;
      // Create the topic's object if not yet created
      if(!hOP.call(topics, topic)) {
        topics[topic] = [];
      }

      // Add the listener to queue
      index = topics[topic].push(finalListener) -1;

      // Provide handle back for removal of topic
      return {
        remove: clear
      };
    },
    once: function(topic, listener) { MW.events.subscribe(topic, listener, true); },
    publish: function(topic /*, splatArgs */) {
      var info = Array.prototype.slice.call(arguments, 1);
      // If the topic doesn't exist, or there's no listeners in queue, just leave
      if(!hOP.call(topics, topic)) {
        !!MW.devMode && console.warn("[NO SUBSCRIBERS]:", topic, info || {}); // jshint ignore:line
        return;
      }
      // if (!topic.match(/(open|hide)_\w+_bar/)) {
        !!MW.devMode && console.info("[EVENT PUBLISHED]:", topic, info || {}); // jshint ignore:line
      // }

      // Cycle through topics queue, fire!
      topics[topic].forEach(function(item) {
        setTimeout(function() {
          item.apply(null, info);
        });
      });
    }
  };
})();